import { render, staticRenderFns } from "./AnaliseProduto4FatGrupoProdutos.vue?vue&type=template&id=68f03a26&scoped=true&"
import script from "./AnaliseProduto4FatGrupoProdutos.vue?vue&type=script&lang=js&"
export * from "./AnaliseProduto4FatGrupoProdutos.vue?vue&type=script&lang=js&"
import style0 from "./AnaliseProduto4FatGrupoProdutos.vue?vue&type=style&index=0&id=68f03a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f03a26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
